import React from 'react';

import { Text as RadixText } from '@radix-ui/themes';
import cn from 'classnames';

import { getFlyToRadixColor } from '../utils';
import { TextProps, sizeToClassName, weightToClassName } from './Text.types';

function Text({
  color,
  size,
  weight,
  as: asProp = 'span',
  ref,
  ...props
}: TextProps & { ref?: React.Ref<HTMLElement> }) {
  return (
    <RadixText
      as={asProp as any}
      {...props}
      color={color ? getFlyToRadixColor(color) : undefined}
      size={size}
      ref={ref}
      className={cn(
        props.className,
        size ? sizeToClassName[size] : '',
        weight ? weightToClassName[weight] : ''
      )}
    />
  );
}

export { Text };
